import { useCallback, MouseEvent, FC } from "react";

import { DashboardChip } from "@/dashboard-design-system/DashboardChip/DashboardChip";

interface EmailChipProps {
  className?: string;
  disabled?: boolean;
  email: string;
  isFaulty?: boolean;
  isUnsubscribed?: boolean;
  onDelete: (email: string) => void;
}

export const EmailChip: FC<EmailChipProps> = ({ className, disabled, email, isFaulty, isUnsubscribed, onDelete }) => {
  const suppressClick = useCallback((event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
  }, []);

  const handleChipDelete = useCallback(() => {
    onDelete(email);
  }, [email, onDelete]);

  return (
    <DashboardChip
      key={email}
      vibe={isUnsubscribed ? "warning" : isFaulty ? "danger" : "brand"}
      variant="outlined"
      label={email}
      className={className}
      onMouseDown={suppressClick}
      onDelete={!disabled ? handleChipDelete : undefined}
      disabled={disabled}
      disableOnClickHover
    />
  );
};
